import { render, staticRenderFns } from "./FeatureTypeCustomForm.vue?vue&type=template&id=55ba8eea&scoped=true"
import script from "./FeatureTypeCustomForm.vue?vue&type=script&lang=js"
export * from "./FeatureTypeCustomForm.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeCustomForm.vue?vue&type=style&index=0&id=55ba8eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba8eea",
  null
  
)

export default component.exports